import { FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
    BooleanParam,
    NumberParam,
    StringParam,
    useQueryParams,
} from 'use-query-params'

import { ReactComponent as Checkmark } from '../../../../../../assets/icons/checkmark.svg'
import { MessagesFiltersEnum } from '../../MessagesFilters'

import styles from './other-category.module.scss'

interface IAdditionalFilters {
    date_from: string | undefined
    date_to: string | undefined
    intent_confidence_from: number | undefined
    intent_confidence_to: number | undefined
    entity_confidence_from: number | undefined
    entity_confidence_to: number | undefined
    message_validated: boolean | undefined
}

function OtherCategory() {
    const { t } = useTranslation()

    const [query, setQuery] = useQueryParams({
        [MessagesFiltersEnum.DATE_FROM]: StringParam,
        [MessagesFiltersEnum.DATE_TO]: StringParam,
        [MessagesFiltersEnum.INTENT_CONFIDENCE_FROM]: NumberParam,
        [MessagesFiltersEnum.INTENT_CONFIDENCE_TO]: NumberParam,
        [MessagesFiltersEnum.ENTITY_CONFIDENCE_FROM]: NumberParam,
        [MessagesFiltersEnum.ENTITY_CONFIDENCE_TO]: NumberParam,
        [MessagesFiltersEnum.MESSAGE_VALIDATED]: BooleanParam,
    })

    const [filters, setFilters] = useState<IAdditionalFilters>({
        date_from: query.date_from || undefined,
        date_to: query.date_to || undefined,
        intent_confidence_from: query.intent_confidence_from || undefined,
        intent_confidence_to: query.intent_confidence_to || undefined,
        entity_confidence_from: query.entity_confidence_from || undefined,
        entity_confidence_to: query.entity_confidence_to || undefined,
        message_validated: query.message_validated || undefined,
    })

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault()
        setQuery(filters)
    }

    return (
        <form className={styles.otherCategory} onSubmit={handleSubmit}>
            <label className={styles.otherCategory__label}>
                {t('date_from')}:
                <input
                    className={styles.otherCategory__input}
                    type="date"
                    value={filters.date_from}
                    onChange={(e) =>
                        setFilters({ ...filters, date_from: e.target.value })
                    }
                />
            </label>
            <label className={styles.otherCategory__label}>
                {t('date_to')}:
                <input
                    className={styles.otherCategory__input}
                    type="date"
                    value={filters.date_to}
                    onChange={(e) =>
                        setFilters({ ...filters, date_to: e.target.value })
                    }
                />
            </label>
            <label className={styles.otherCategory__label}>
                {t('intent_confidence_from')}:
                <input
                    className={styles.otherCategory__input}
                    type="number"
                    value={filters.intent_confidence_from}
                    onChange={(e) =>
                        setFilters({
                            ...filters,
                            intent_confidence_from: Number(e.target.value),
                        })
                    }
                    min={0}
                    max={1}
                    step={0.01}
                />
            </label>
            <label className={styles.otherCategory__label}>
                {t('intent_confidence_to')}:
                <input
                    className={styles.otherCategory__input}
                    type="number"
                    value={filters.intent_confidence_to}
                    onChange={(e) =>
                        setFilters({
                            ...filters,
                            intent_confidence_to: Number(e.target.value),
                        })
                    }
                    min={0}
                    max={1}
                    step={0.01}
                />
            </label>
            <label className={styles.otherCategory__label}>
                {t('entity_confidence_from')}:
                <input
                    className={styles.otherCategory__input}
                    type="number"
                    value={filters.entity_confidence_from}
                    onChange={(e) =>
                        setFilters({
                            ...filters,
                            entity_confidence_from: Number(e.target.value),
                        })
                    }
                    min={0}
                    max={1}
                    step={0.01}
                />
            </label>
            <label className={styles.otherCategory__label}>
                {t('entity_confidence_to')}:
                <input
                    className={styles.otherCategory__input}
                    type="number"
                    value={filters.entity_confidence_to}
                    onChange={(e) =>
                        setFilters({
                            ...filters,
                            entity_confidence_to: Number(e.target.value),
                        })
                    }
                    min={0}
                    max={1}
                    step={0.01}
                />
            </label>
            <label className={styles.otherCategory__label}>
                {t('message_validated')}:
                <input
                    className={styles.otherCategory__input}
                    type="checkbox"
                    checked={filters.message_validated}
                    onChange={() =>
                        setFilters({
                            ...filters,
                            message_validated: !filters.message_validated,
                        })
                    }
                />
            </label>
            <button className={styles.otherCategory__btn} type="submit">
                <Checkmark className={styles.otherCategory__btnIcon} />
            </button>
        </form>
    )
}

export default OtherCategory
